import Vue from "vue";
import VueRouter, { useRoute } from "vue-router";
import Home from "../views/Home.vue";
import personalCenter from "../views/personalCenter.vue";
import store from "../store";
import { Loading, message } from "element-ui";
import { $userDetail, $crmPlaceGetCrmOrder } from "@/api";
import axios from "axios";
// 路由重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "西顿照明-首页" },
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login.vue"),
    meta: { title: "登录" },
  },

  {
    path: "/Forgot_password",
    name: "Forgot_password",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Forgot_password.vue"),
    meta: { title: "忘记密码" },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },

  {
    path: "/personal_center",
    name: "personal_center",
    redirect: "/dashboard",
    component: personalCenter,
    children: [
      {
        path: "/dashboard",
        component: () => import("@/views/dashboard.vue"),
        name: "dashboard",
        meta: { title: "仪表盘" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/ordermanage",
    redirect: "/ordermanage/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/orderManage.vue"),
        name: "ordermanage",
        meta: { title: "订单管理" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/orderdetails",
    redirect: "/orderdetails/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/orderDetails.vue"),
        name: "orderdetails",
        meta: { title: "订单详情" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/personalinfo",
    redirect: "/personalinfo/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/personaliInfo.vue"),
        name: "personalinfo",
        meta: { title: "个人信息" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/changepassword",
    redirect: "/changepassword/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/changePassword.vue"),
        name: "changepassword",
        meta: { title: "修改密码" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/defaultinvoice",
    redirect: "/defaultinvoice/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/defaultInvoice.vue"),
        name: "defaultinvoice",
        meta: { title: "默认发票信息" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/mycourses",
    redirect: "/mycourses/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/myCourses.vue"),
        name: "mycourses",
        meta: { title: "我的课程" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/notification",
    redirect: "/notification/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/notification.vue"),
        name: "notification",
        meta: { title: "消息通知" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/clouddesignsolution",
    redirect: "/clouddesignsolution/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/cloudDesignSolution.vue"),
        name: "clouddesignsolution",
        meta: { title: "云设计方案管理" },
      },
    ],
    meta: { title: "个人中心" },
  },

  {
    path: "/dailymanage",
    redirect: "/dailymanage/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/dailyManage.vue"),
        name: "dailymanage",
        meta: { title: "日报管理" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/dailycreate",
    redirect: "/dailycreate/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/createDaily.vue"),
        name: "dailycreate",
        meta: { title: "创建日报" },
      },
    ],
    meta: { title: "个人中心" },
  },
  {
    path: "/financialmanage",
    redirect: "/financialmanage/index",
    component: personalCenter,
    children: [
      {
        path: "index",
        component: () => import("@/views/financialManage.vue"),
        name: "financialmanage",
        meta: { title: "财务管理" },
      },
    ],
    meta: { title: "个人中心" },
  },

  {
    path: "/technical_services",
    name: "technical_services",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/technical_services.vue"),
    meta: {
      title: "技术服务",
    },
  },

  {
    path: "/smart_lighting",
    name: "smart_lighting",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/smartLighting.vue"),
    meta: {
      title: "智能照明",
    },
  },
  {
    path: "/product_detail",
    name: "product_detail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/productDetail.vue"),
    meta: {
      title: "产品详情",
    },
  },

  {
    path: "/smart_product",
    name: "smart_product",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/smartProduct.vue"),
    meta: {
      title: "智能产品",
    },
  },
  {
    path: "/case_details",
    name: "case_details",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/caseDetails.vue"),
    meta: {
      title: "案例详情",
    },
  },
  {
    path: "/training_services",
    name: "training_services",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/trainingServices.vue"),
    meta: {
      title: "培训服务",
    },
  },

  {
    path: "/coursed_details",
    name: "coursed_details",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/courseDetails.vue"),
    meta: {
      title: "课程详情",
    },
  },

  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/aboutUs.vue"),
    meta: {
      title: "业务介绍",
    },
  },
  {
    path: "/aboutIntroduce",
    name: "aboutIntroduce",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/aboutIntroduce.vue"),
    meta: {
      title: "关于我们",
    },
  },
  {
    path: "/sign_up",
    name: "sign_up",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/signUp.vue"),
    meta: {
      title: "报名",
    },
  },
  {
    path: "/searchResults",
    name: "searchResults",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/searchResults.vue"),
    meta: {
      title: "搜索结果",
    },
  },
  {
    path: "/cloudDesign",
    name: "cloudDesign",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/cloudDesign.vue"),
    meta: {
      title: "西顿云设计",
    },
  },
  {
    path: "/cloud_edit_design",
    name: "cloudEditDesign",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/cloudEditDesign.vue"),
    meta: {
      title: "西顿云设计",
    },
  },
  {
    path: "/helpDetails",
    name: "helpDetails",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/helpDetails.vue"),
    meta: {
      title: "帮助详情",
    },
  },
  {
    path: "/information_binding",
    name: "information_binding",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/wx_informationBinding.vue"
      ),
    meta: {
      title: "微信绑定",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/_dp_/",
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : "西顿照明"; //将路由标题修改到页面顶部

  // console.log(to.query, "to.query");

  // 不可访问_权限
  let forbiddenPermissions = [
    6, // 分销商id
  ];
  // 仅登录可访问
  const loginPageOnly = [
    "personal_center",
    "dashboard",
    "ordermanage",
    "orderdetails",
    "personalinfo",
    "changepassword",
    "defaultinvoice",
    "mycourses",
    "notification",
    "clouddesignsolution",
    "dailymanage",
    "dailycreate",
    "financialmanage",
    "technical_services",
    "sign_up",
    "cloudDesign",
    "aboutUs",
  ];
  // 无需登录可访问
  let noLoginPermission = [];

  // 是否有自动登录
  let autoLoginCheck = store.state.checked;
  let cacheUserInfo;

  if (!autoLoginCheck) {
    cacheUserInfo = sessionStorage.getItem("cdntoken");
  } else {
    cacheUserInfo = store.state.userInfo.token;
  }

  // 获取重定向跳转携带参数 post_name
  let post_name_data = GetQueryString("post_name");
  // 跳转路由且携带参数
  let dec_url = "";
  if (post_name_data) {
    dec_url = post_name_data.substr(
      decodeURIComponent(post_name_data).indexOf("?")
    );
  }
  let ct_token = null;
  let ct_data;
  let ct = GetQueryString("ct") || GetPathParmasString(dec_url, "ct");
  if (to.name == "technical_services" && to.query.ct) {
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (mobile) {
      // const url = `${location.origin}/_mo_/technical_services/index?localcrm=${cd}&crm_order_type_sub=${to.query.crm_order_type_sub || 1}`;
      let queryString = '';
      for(const key in to.query){
        queryString+=`${key}=${to.query[key]}&`
      }
      // const url = `http://localhost:8082/_mo_/technical_services/index?${queryString}`;
      const url = `${location.origin}/_mo_/technical_services/index?${queryString}`;
      window.location.replace(url);
      return
    }
    try {
      ct_data = await $crmPlaceGetCrmOrder({
        ct,
      });
      ct_token = ct_data.data.token;
      if (ct_token) {
        await sessionStorage.setItem("cdntoken", ct_token);
        await store.commit(
          "SetUserInfo",
          Object.assign(store.state.userInfo, { token: ct_token })
        );
        // let ct_pars = "";
        // Object.keys(ct_data.data).forEach((item) => {
        //   ct_pars += `${item}=${ct_data.data[item]}&`;
        // });
        store.commit("saveCrmInfo", ct_data.data);
      }
    } catch (error) {
      ct_data = null;
    }
    if (!ct_data) {
      message("登录已超时，请重新登录");
      return next("/login");
    }
  }

  // 获取token
  let path_search_token =
    ct_token ||
    GetQueryString("token") ||
    GetPathParmasString(dec_url, "token");
  if (path_search_token) {
    cacheUserInfo = path_search_token;
    await sessionStorage.setItem("cdntoken", path_search_token);
    await store.commit(
      "SetUserInfo",
      Object.assign(store.state.userInfo, { token: path_search_token })
    );
    // let userInfo = await $userDetail();
    // store.commit('SetUserInfo', userInfo.data)
    await store.commit("SetChecked", true);
    // 更新 用户信息
    let path_result = {};
    try {
      path_result = await $userDetail({});
    } catch (error) {
      path_result = {
        data: {},
      };
    }
    if (path_result) {
      store.commit("SetUserInfo", {
        ...path_result.data,
        token: cacheUserInfo,
      });
    }
  }

  if (to.name == "technical_services" && to.query.ct) {
    let cd = guid();
    store.commit("changeCrminfoCd", cd);
    next(`/technical_services?localcrm=${cd}&crm_order_type_sub=${to.query.crm_order_type_sub || 1}`);
    return;
  }

  if (cacheUserInfo) {
    let cacheIdentity = store.state.userInfo.user_code;
    if (
      forbiddenPermissions.indexOf(cacheIdentity) != -1 &&
      to.name == "technical_services"
    ) {
      message("分销商不可下单");
      next("/");
    } else {
      next();
    }
  } else if (loginPageOnly.indexOf(to.name) != -1) {
    message({
      message: "未登录不可访问",
      showClose: true,
    });
    next("/");
  } else {
    next();
  }
});

// 跳转后返回顶部
router.afterEach(async (to, from, next) => {
  window.scrollTo(0, 0);
});

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
function GetPathParmasString(path, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = path.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
function guid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}
export default router;
